import { createUseStyles } from "react-jss";

export const useStyles = () => {
  return createUseStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
    },
  })();
};
